import { Children } from 'react';

export const Each = ({ render, of, fieldOfIndex }) =>
  Children.toArray(
    of.map((item, index) => {
      return render(item, fieldOfIndex ? item[fieldOfIndex] : index);
    }),
  );
